import React from 'react';

import { IconGrid, IconGridActive, IconGridVertical, IconGridVerticalActive } from '@/assets';
import RenderWhen from '@/components/RenderWhen';

import type { TypeLayout } from './useListLayout';

const ListLayout: React.FC<{
  type: TypeLayout;
  changeTypeLayout: (type: TypeLayout) => void;
}> = ({ type, changeTypeLayout }) => {
  return (
    <div className="inline-flex rounded-[100px] bg-[#F8F9FD] p-[3px]">
      <div
        onClick={() => changeTypeLayout('col')}
        aria-selected={type === 'col'}
        className="flex h-[40px] w-[40px] cursor-pointer items-center justify-center rounded-[50%] aria-selected:bg-white"
      >
        <RenderWhen>
          <RenderWhen.If isTrue={type === 'col'}>
            <IconGridActive />
          </RenderWhen.If>
          <RenderWhen.If isTrue={type === 'row'}>
            <IconGrid />
          </RenderWhen.If>
        </RenderWhen>
      </div>
      <div
        onClick={() => changeTypeLayout('row')}
        aria-selected={type === 'row'}
        className="flex h-[40px] w-[40px] cursor-pointer items-center justify-center rounded-[50%] aria-selected:bg-white"
      >
        <RenderWhen>
          <RenderWhen.If isTrue={type === 'row'}>
            <IconGridVerticalActive />
          </RenderWhen.If>
          <RenderWhen.If isTrue={type === 'col'}>
            <IconGridVertical />
          </RenderWhen.If>
        </RenderWhen>
      </div>
    </div>
  );
};

export default ListLayout;
